const wrapRootElement = require('./src/wrap-root-element').default
const {
  isChunkError,
  reloadOnceForChunkError,
} = require('./src/utils/chunkReload')

exports.wrapRootElement = wrapRootElement

exports.onClientEntry = () => {
  const LocalStorageInterceptor = require('./src/utils/localStorageInterceptor')
    .default
  const localStorageConfigs = require('./src/config/localStorage').default
  LocalStorageInterceptor.init(localStorageConfigs)

  window.addEventListener('unhandledrejection', event => {
    if (isChunkError(event?.reason)) {
      reloadOnceForChunkError(event.reason)
    }
  })

  window.addEventListener('error', event => {
    if (isChunkError(event?.error)) {
      reloadOnceForChunkError(event.error)
    }
  })
}

exports.onRouteUpdate = () => {
  const LocalStorageInterceptor = require('./src/utils/localStorageInterceptor')
    .default
  LocalStorageInterceptor.validate()
}
